import styled from 'styled-components';

import {
  colorBlack900,
  colorGraySemiLight,
  colorGrey400,
  fontFamilySecondary,
  mediaQueryLaptopMin,
  mediaQueryMobileLargeMin,
} from 'styles';
import { CommentsLink } from 'components/ExchangeDiscussion/styles';

export const Title = styled.a`
  font-family: ${fontFamilySecondary};
  font-weight: 700;
  font-size: 18px;
  color: ${colorBlack900};
  line-height: 24px;
  margin: 0;
  text-decoration: none;
  display: block;
  transition: opacity 0.3s;
  padding-bottom: 16px;

  &:hover {
    opacity: 0.8;
  }
`;

export const Date = styled.div`
  color: ${colorGrey400};
  font-size: 13px;
  line-height: 18px;
  margin-bottom: 4px;
`;

export const AuthorImg = styled.img`
  display: block;
  width: 32px;
  height: 32px;
  margin-right: 8px;
  overflow: hidden;
  object-fit: cover;
  border-radius: 50%;
`;

export const BlogsItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media all and ${mediaQueryMobileLargeMin} {
    flex-direction: row;
  }

  @media all and ${mediaQueryLaptopMin} {
    flex-direction: column;
  }
`;

export const BlogsContent = styled.div`
  width: 100%;
  margin-bottom: 12px;
`;

export const AuthorContent = styled.a`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const AuthorName = styled.div`
  font-weight: 700;
  font-size: 13px;
  line-height: 18px;
  color: ${colorBlack900};
`;

export const ItemLink = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  color: ${colorBlack900};
  font-size: 14px;
  line-height: 20px;
  transition: opacity 0.3s;
  border: 1px solid ${colorGraySemiLight};
  border-radius: 8px;
  flex: 1;

  a {
    color: ${colorBlack900};
  }

  &:hover {
    opacity: 0.8;
  }
`;

export const BlogsButton = styled(CommentsLink)`
  width: 100%;
`;
